import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * XP setting for Faire Direct signup modal refresh
 * https://www.notion.so/faire/FD-Signup-Modal-Updates-1302efb5c25a80909bf6cc4a109671ee
 */
export const FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110 = experiment({
  name: "FE_FAIRE_DIRECT_SIGNUP_MODAL_REFRESH_250110",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-04-07",
  productArea: "FAIRE_DIRECT",
  defaultValue: false,
});
